module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name,
      "name": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "type": _vm.field.type,
      "maxlength": _vm.field.maxSize,
      "minlength": _vm.field.minSize,
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.input
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70708561","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/NumberRender.vue
// module id = 1695
// module chunks = 1